import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal, Button, InputGroup, Form } from "react-bootstrap";
import { Icon } from "@iconify/react";
import UploadImageComponent from "../UploadImageComponent";
import { useStore } from "../../store";
import { get_membe_by_member_no } from "../../services/membership.service";
import converSex from "../../helpers/convertSex";
import { END_IMAGE } from "../../constants";
import convertNumber from "../../helpers/convertNumber";
import convertNumberReverse from "../../helpers/convertNumberReverse";
import convertTypeLoan from "../../helpers/convertTypeLoan";
import LoadingComponent from "../LoadingComponent";
import FormControlCustom from "../FormControlCustom";
import { WarningError } from "../../helpers/alertseet";
import addBranchNo from "../../helpers/addBranchNo";
export default function PopUpUpdateLoan({
  open,
  onClose,
  popup,
  onSubmit,
  setPopup,
  setBackupFormData,
  backupFormData,
}) {
  // state
  const [isLoading, setIsLoading] = useState(false); // loading
  const [searchLoading, setSearchLoading] = useState(false); // loading
  const [inputSearch, setInputSearch] = useState("");
  const [memberData, setMemberData] = useState();
  const [selectLoanType, setSelectLoanType] = useState();
  const [disableButton, setDisableButton] = useState(false);
  const [formData, setFormData] = useState();
  const [validate, setValidate] = useState({
    branchId: false,
    memberId: false,
    description: false,
    loanAmount: false,
    loanTerm: false,
    loanType: false,
    contractImage: false,
    exceptPaymentFirstTwoTerm: false,
  });
  const [validateMessage, setValidateMessage] = useState({
    balanceAmount: "",
    description: "",
  });

  // store
  const { token, profile, branchData } = useStore();

  // useEffect
  useEffect(() => {
    if (profile?.branchId) {
      setFormData((prev) => ({ ...prev, branchId: profile?.branchId }));
    }
    if (backupFormData) {
      setFormData((prev) => ({ ...prev, ...backupFormData?.formData }));
      setMemberData(backupFormData?.memberData);
      setInputSearch(backupFormData?.inputSearch);
    }
  }, [backupFormData, open]);
  useEffect(() => {
    if (selectLoanType === "DECREASE_INTEREST") {
      setFormData((prev) => ({ ...prev, loanType: "DECREASE_INTEREST" }));
    } else {
      setFormData((prev) => ({ ...prev, loanType: "" }));
    }
  }, [selectLoanType]);
  useEffect(() => {
    if (profile?.branchId) {
      setFormData((prev) => ({ ...prev, branchId: profile?.branchId }));
    }
  }, [popup, profile]);
  // function
  const checkValidate = () => {
    let _validate = {};
    let _validateMessage = {};
    let state = false;
    if (!memberData?._id) {
      _validate.memberData = true;
      _validateMessage.memberData = "ຄົ້ນຫາຕາມເລກສະມາຊິກ";
      state = true;
      console.log("1");
    }
    if (!formData?.branchId) {
      _validate.branchId = true;
      state = true;
      console.log("2");
    }
    if (!formData?.memberId) {
      _validate.memberId = true;
      state = true;
      console.log("3");
    }
    if (!formData?.description) {
      _validate.description = true;
      state = true;
      console.log("4");
    }

    if (!formData?.loanAmount) {
      _validate.loanAmount = true;
      _validateMessage.loanAmount = "ກະລຸນາປ້ອນຈຳນວນເງິນ";
      state = true;
      console.log("5");
    }
    // ຖ້າຍັງບໍ່ມີການຝາກເງິນແມ່ນ ກູ້ບໍ່ໄດ້
    if (!memberData?.balanceId?.totalBalance) {
      WarningError("ຜູ້ກູ້ຕ້ອງມີເງິນໃນບັນຊີກ່ອນ");
      state = true;
      console.log("6");
    }
    // DONE: validate ດຸນພິນິດ
    /**
     * ກວດດຸນພິນິດ
     */
    if (!formData?.manualCheck) {
      if (formData?.loanAmount / 3 > memberData?.balanceId?.totalBalance) {
        _validate.loanAmount = true;
        _validateMessage.loanAmount =
          "ຈຳນວນເງິນກູ້ຕ້ອງບໍ່ເກີນ 3 ເທົ່າຂອງເງິນຝາກ";
        state = true;
        console.log("7");
      }
    }

    if (!formData?.loanTerm) {
      _validate.loanTerm = true;
      state = true;
      console.log("8");
    }
    if (!formData?.loanType) {
      _validate.loanType = true;
      state = true;
      console.log("9");
    }
    if (!formData?.contractImage) {
      _validate.contractImage = true;
      state = true;
      console.log("10");
    }
    // if (formData?.loanTerm === "1") {
    //   if (formData?.exceptPaymentFirstTwoTerm) {
    //     _validate.exceptPaymentFirstTwoTerm = true;
    //     state = true;
    //   }
    // }
    setValidateMessage((prev) => ({
      ...prev,
      ..._validateMessage,
    }));
    setValidate(_validate);
    return state;
  };
  const handleSearchMember = async () => {
    try {
      if (!inputSearch) return;
      setIsLoading(true);
      setSearchLoading(true);
      setMemberData();
      const member = await get_membe_by_member_no(
        addBranchNo(inputSearch, branchData?.branchNo),
        token
      );

      if (member?.error) {
        console.log("hear");
        setValidateMessage((prev) => ({
          ...prev,
          memberData: "ບໍ່ພົບຂໍ້ມູນສະມາຊິກ",
        }));
        throw new Error(member?.message);
      }
      const data = member?.data;
      if (!data) {
        console.log("hear");
        setValidateMessage((prev) => ({
          ...prev,
          memberData: "ບໍ່ພົບຂໍ້ມູນສະມາຊິກ",
        }));
        throw new Error("memberData empty");
      }
      setValidateMessage((prev) => ({
        ...prev,
        memberData: "",
      }));
      setValidate((prev) => ({ ...prev, memberData: false }));

      setMemberData(data);
      setFormData((prev) => ({
        ...prev,
        memberId: data?._id,
        fullName: data?.fullName,
        gender: data?.gender,
        balanceId: data?.balanceId,
      }));
      setIsLoading(false);
      setSearchLoading(false);
    } catch (err) {
      setValidate((prev) => ({ ...prev, memberData: true }));
      setMemberData();
      console.error("error", err);
      setIsLoading(false);
      setSearchLoading(false);
    }
  };
  const handleCreateLoan = async () => {
    try {
      setDisableButton(true);
      const stateCheck = checkValidate();
      if (stateCheck) {
        setDisableButton(false);
        throw new Error("validate");
      }
      const status = await onSubmit(formData);
      if (!status.error) {
        setFormData();
        setValidate();
        setMemberData();
        setInputSearch("");
        onClose();
      }
      setDisableButton(false);
    } catch (err) {
      console.error(err);
      setIsLoading(false);
      setDisableButton(false);
    }
  };
  const handleClose = async () => {
    setFormData();
    setValidate();
    setMemberData();
    setInputSearch("");
    onClose();
  };

  return (
    <Modal show={open} onHide={handleClose} backdrop="static" size="lg">
      <Modal.Header
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          fontWeight: 700,
          // backgroundColor: "#e9ecef",
        }}
      >
        ປ້ອນຂໍ້ມູນເງີນກູ້
      </Modal.Header>
      <Modal.Body
        style={{
          boxSizing: "border-box",
          overflow: "auto",
          width: "100%",
        }}
      >
        <div>
          <div style={{ display: "flex" }}>
            {/* TODO: ແປງ ui ຊ່ວງຄົ້ນຫາ */}
            <label>ເລກສະມາຊິກ</label>
            <div style={{ flex: 1 }}></div>
            <label>(ກົດປຸ່ມເພື່ອຄົ້ນຫາ)</label>
          </div>
          <div style={{ marginBottom: 20 }}>
            <InputGroup>
              <Form.Control
                disabled
                maxLength="4"
                placeholder="ປ້ອນເລກສະມາຊິກ"
                style={{ borderRight: "none" }}
                value={inputSearch}
                onChange={(e) => {
                  convertNumberReverse(e.target.value, (value) => {
                    setInputSearch(value);
                  });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearchMember();
                  }
                }}
                isInvalid={validate?.memberData}
              />
              <InputGroup.Text
                style={{
                  backgroundColor: "#0178C1",
                  border: "none",
                  cursor: "pointer",
                }}
                // onClick={handleSearchMember}
              >
                <Icon
                  icon="tabler:search"
                  style={{ width: 24, height: 24, color: "#FFFFFF" }}
                />
              </InputGroup.Text>
            </InputGroup>
            <div
              style={{
                display:
                  validate?.memberData && validateMessage?.memberData
                    ? "flex"
                    : "none",
                color: "#FF0000",
                gap: 5,
                alignItems: "center",
              }}
            >
              <Icon
                icon="material-symbols:info-outline"
                style={{ width: 18, height: 18 }}
              />
              <span>{validateMessage?.memberData}</span>
            </div>
          </div>
        </div>
        <div
          style={{
            display: searchLoading ? "flex" : "none",
            justifyContent: "center",
            height: 150,
            alignItems: "center",
          }}
        >
          <LoadingComponent />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 20,
            marginBottom: 20,
          }}
        >
          {[
            {
              title: "ຊື່ ແລະ ນາມສະກຸນ:",
              value: memberData?.fullName ? memberData?.fullName : "-",
            },
            {
              title: "ເພດ:",
              value: memberData?.gender ? converSex(memberData?.gender) : "-",
            },
            // {
            //   title: "ຈຳນວນເງິນອອມ (ກີບ):",
            //   value: memberData?.balanceId?.totalBalance
            //     ? convertNumber(memberData?.balanceId?.totalBalance)
            //     : "-",
            // },
            // {
            //   title: "ຄະແນນ:",
            //   value: memberData?.balanceId?.totalPoint
            //     ? convertNumber(memberData?.balanceId?.totalPoint)
            //     : "-",
            // },
          ].map((e, i) => (
            <div className="list-data" key={i}>
              <div>{e?.title}</div>
              <div>{e?.value}</div>
            </div>
          ))}
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຈຳນວນເງິນກູ້ (ກີບ)</Form.Label>
          <FormControlCustom
            placeholder="ປ້ອນຈຳນວນເງິນກູ້"
            type="text"
            value={convertNumber(formData?.loanAmount)}
            isInvalid={validate?.loanAmount}
            isInvalidMessage={validateMessage?.loanAmount}
            defaultValue=""
            onChange={(e) => {
              convertNumberReverse(e.target.value, (value) => {
                setFormData((prev) => ({
                  ...prev,
                  loanAmount: value,
                }));
              });
            }}
          />
        </div>
                  {/* DONE:  ດຸນພິນິດຕ້ອນສ້າງລາຍການ ເງິນກູ້ */}
        {/* <div style={{ marginBottom: 20 }}>
          <Form.Check // prettier-ignore
            type="checkbox"
            id={`default-checkbox`}
            label={`ກູ້ເກີນ 3 ເທົ່າຂອງຈຳນວນເງິນອອມ`}
            checked={formData?.manualCheck}
            onChange={() => {
              setBackupFormData({
                formData: formData,
                memberData: memberData,
                inputSearch: inputSearch,
              });
              setPopup({ PopUpConfirmDiscretion_for_update: true });
            }}
          />
        </div> */}
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ດອກເບ້ຍ (%)</Form.Label>
          <Form.Control disabled value={formData?.interestRate * 100 || ""} />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຈຳນວນງວດ (ເດືອນ)</Form.Label>
          <Form.Select
            disabled
            value={formData?.loanTerm || ""}
            isInvalid={validate?.loanTerm}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, loanTerm: e?.target.value }))
            }
          >
            <option value="" disabled>
              ເລືອກຈຳນວນງວດ
            </option>
            {[...new Array(12)].map((e, i) => (
              <option value={i + 1}>{i + 1}</option>
            ))}
          </Form.Select>
          <div
            style={{
              display: validate?.loanTerm ? "flex" : "none",
              color: "#FF0000",
              gap: 5,
              alignItems: "center",
            }}
          >
            <Icon
              icon="material-symbols:info-outline"
              style={{ width: 18, height: 18 }}
            />
            <span>ກະລຸນາເລືອກຈຳນວນງວດ</span>
          </div>
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຮູບແບບການຊຳລະດອກເບ້ຍ</Form.Label>
          <Form.Select
            disabled
            value={selectLoanType || ""}
            isInvalid={validate?.loanType}
            onChange={(e) => setSelectLoanType(e?.target.value)}
          >
            <option value="" disabled>
              ເລືອກປະເພດ
            </option>
            <option value="DECREASE_INTEREST">
              {convertTypeLoan("DECREASE_INTEREST")}
            </option>
               <option value="ALL_CONSTANT_INTEREST">
                          {convertTypeLoan("ALL_CONSTANT_INTEREST")}
                </option>
            <option value="CONSTANT_INTEREST_AND_CLOSURE_INTEREST">
              ດອກເບ້ຍຄົງທີ່ ແລະ ບໍ່ໄດ້ຊຳລະຕົ້ນທືນ
            </option>
          </Form.Select>
          <div
            style={{
              display: validate?.loanType ? "flex" : "none",
              color: "#FF0000",
              gap: 5,
              alignItems: "center",
            }}
          >
            <Icon
              icon="material-symbols:info-outline"
              style={{ width: 18, height: 18 }}
            />
            <span>ກະລຸນາເລືອກປະເພດ</span>
          </div>
        </div>
        <div
          style={{
            display:
              selectLoanType === "DECREASE_INTEREST" || !selectLoanType
                ? "none"
                : "block",
            marginBottom: 16,
          }}
        >
          <Form.Label>ຕົວເລືອກ</Form.Label>
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <Form.Check
              disabled
              type="radio"
              label={`ຊຳລະດອກເບ້ຍລາຍເດືອນ, ຕົ້ນທຶນຊຳລະຕາມໄລຍະ
              ສິ້ນສຸດທີ່ສັນຍາກຳນົດ`}
              name="sex"
              id="radio-loanType-2"
              isInvalid={validate?.loanType}
              value="CONSTANT_INTEREST"
              checked={formData?.loanType === "CONSTANT_INTEREST"}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  loanType: e.target.value,
                }))
              }
            />
            <Form.Check
              disabled
              type="radio"
              label={`ຊຳລະດອກເບ້ຍ ຕາມໄລຍະສິ້ນສຸດທີ່ສັນຍາກຳນົດ 
              ພ້ອມຕົ້ນທຶນ`}
              name="sex"
              id="radio-loanType-3"
              isInvalid={validate?.loanType}
              value="CLOSURE_INTEREST"
              checked={formData?.loanType === "CLOSURE_INTEREST"}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  loanType: e.target.value,
                }))
              }
            />
          </div>
        </div>
        {/* <div style={{ marginBottom: 20 }}>
          <Form.Check
            disabled
            type="checkbox"
            label={`ຍົກເວັ້ນດອກເບ້ຍ 2 ເດືອນ`}
            name="EXCEPT_PAYMENT_FIRST_TWO_TERM"
            id="check-exceptPaymentFirstTwoTerm-1"
            isInvalid={validate?.exceptPaymentFirstTwoTerm}
            checked={formData?.exceptPaymentFirstTwoTerm}
            onClick={(e) => {
              setFormData((prev) => ({
                ...prev,
                exceptPaymentFirstTwoTerm: !formData?.exceptPaymentFirstTwoTerm,
              }));
            }}
          />
        </div> */}
        <div style={{ marginBottom: 20 }}>
          <Form.Label>
            ເຫດຜົນ
            {/* <span style={{ color: "#CED4DA" }}>(ບໍ່ກຳນົດ)</span> */}
          </Form.Label>
          <Form.Control
            as="textarea"
            placeholder="ປ້ອນເຫດຜົນ"
            style={{ height: "100px" }}
            value={formData?.description}
            isInvalid={validate?.description}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, description: e?.target.value }))
            }
          />
          <div
            style={{
              display: validate?.description ? "flex" : "none",
              color: "#FF0000",
              gap: 5,
              alignItems: "center",
            }}
          >
            <Icon
              icon="material-symbols:info-outline"
              style={{ width: 18, height: 18 }}
            />
            <span>ກະລຸນາປ້ອນລາຍລະອຽດ</span>
          </div>
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຮູບພາບສັນຍາ</Form.Label>
          <UploadImageComponent
            src={
              formData?.contractImage ? END_IMAGE + formData?.contractImage : ""
            }
            isInvalid={validate?.contractImage}
            style={{ width: "100%", height: "200px", maxHeight: "200px" }}
            onChange={(image) =>
              setFormData((prev) => ({
                ...prev,
                contractImage: image,
              }))
            }
          />
          <div
            style={{
              display: validate?.contractImage ? "flex" : "none",
              color: "#FF0000",
              gap: 5,
              alignItems: "center",
            }}
          >
            <Icon
              icon="material-symbols:info-outline"
              style={{ width: 18, height: 18 }}
            />
            <span>ກະລຸນາອັບໂຫລດຮູບສັນຍາ</span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ marginBottom: 30 }}>
        <div style={{ width: "100%", display: "flex", gap: 10 }}>
          <Button
            variant="outline-primary"
            style={{ flex: 1 }}
            onClick={handleClose}
          >
            ຍົກເລີກ
          </Button>
          <Button
            style={{ flex: 1 }}
            disabled={disableButton}
            onClick={() => {
              handleCreateLoan();
            }}
          >
            ບັນທຶກ
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
